// Provided & curated imagery for Our Promise Events

// Uploaded by client (self-hosted in /public/fotos)
export const SERVICE_IMAGES = {
  reinigungsservice: "/fotos/reinigung.jpg?v=4",
  security: "/fotos/security-v2.jpg?v=2",
  serviceTeam: "/fotos/service-team.jpg?v=2",
};

export const HERO_IMAGE = "/fotos/hero.jpg?v=2";

export const CTA_IMAGE =
  "https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?auto=format&fit=crop&w=2000&q=80";

export const ABOUT_IMAGE =
  "https://images.unsplash.com/photo-1535428245347-3ab06a1b100a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHw0fHxibGFjayUyMGNvdXBsZSUyMGVsZWdhbnQlMjB3ZWRkaW5nfGVufDB8fHx8MTc4MjA4Mzg5MXww&ixlib=rb-4.1.0&q=85";

// Founder portrait (M. Koko) and team group photo
export const FOUNDER_IMAGE = "/fotos/founder.jpg";
export const TEAM_IMAGE = "/fotos/team.jpg";

// Package images (client uploads): bronze = rose gold rings, gold = gold rings with diamond, silber = rings crop
export const PACKAGE_IMAGES = {
  bronze: "/fotos/bronze.jpg?v=2",
  silber: "/fotos/silber.jpg?v=2",
  gold: "/fotos/gold.jpg?v=2",
};

// Editorial imagery for home + Eindrücke gallery (client's own photos + diverse couples)
export const GALLERY_SEED = [
  { url: "/fotos/moment-couple-hands-champagne.jpg", cat: "hochzeit", alt_de: "Brautpaar hält Hände mit Champagner", alt_fr: "Les mariés se tiennent la main avec du champagne" },
  { url: "/fotos/moment-silhouette-champagne.jpg", cat: "hochzeit", alt_de: "Silhouette Brautpaar mit Champagner in Schwarz-Weiss", alt_fr: "Silhouette des mariés avec champagne en noir et blanc" },
  { url: "/fotos/moment-couple-night.jpg", cat: "hochzeit", alt_de: "Brautpaar feiert – Braut lacht in den Armen des Bräutigams", alt_fr: "Les mariés célèbrent – la mariée rit dans les bras du marié" },
  { url: "/fotos/moment-bride-portrait.jpg", cat: "hochzeit", alt_de: "Elegantes Braut-Portrait beim Getting Ready", alt_fr: "Portrait élégant de la mariée aux préparatifs" },
  { url: "/fotos/moment-silver-accessories.jpg", cat: "hochzeit", alt_de: "Braut-Accessoires: Silberne Schuhe und Clutch", alt_fr: "Accessoires de la mariée : escarpins et pochette argentés" },
  { url: "/fotos/moment-signing.jpg", cat: "hochzeit", alt_de: "Brautpaar unterschreibt die Trauurkunde", alt_fr: "Les mariés signent l'acte de mariage" },
  { url: "/fotos/moment-rings-hands.jpg", cat: "hochzeit", alt_de: "Hände des Brautpaars mit Trauringen", alt_fr: "Mains des mariés avec les alliances" },
  { url: "/fotos/moment-veil-park.jpg", cat: "hochzeit", alt_de: "Braut mit langem Schleier im Park", alt_fr: "Mariée avec long voile dans le parc" },
  { url: "/fotos/moment-getting-ready-men.jpg", cat: "hochzeit", alt_de: "Bräutigam beim Getting Ready mit Vater", alt_fr: "Marié aux préparatifs avec son père" },
  { url: "/fotos/moment-bride-silhouette.jpg", cat: "hochzeit", alt_de: "Braut-Silhouette am Fenster", alt_fr: "Silhouette de la mariée à la fenêtre" },
  { url: "/fotos/moment-1.jpg", cat: "hochzeit", alt_de: "Brautpaar bei der Trauung im Garten", alt_fr: "Couple de mariés lors de la cérémonie au jardin" },
  { url: "/fotos/moment-4.jpg", cat: "hochzeit", alt_de: "Braut beim Make-up (Getting Ready)", alt_fr: "Mariée au maquillage (préparatifs)" },
  { url: "/fotos/moment-5.jpg", cat: "hochzeit", alt_de: "Blumenmädchen mit Brautstrauss", alt_fr: "Demoiselle d'honneur avec bouquet" },
  { url: "/fotos/gold.jpg", cat: "hochzeit", alt_de: "Ringtausch des Brautpaars", alt_fr: "Échange des alliances" },
  { url: "/fotos/bronze.jpg", cat: "weitere", alt_de: "Eheringe in Roségold", alt_fr: "Alliances en or rose" },
  { url: "/fotos/silber.jpg", cat: "weitere", alt_de: "Eheringe", alt_fr: "Alliances" },
];
